

















import Vue from 'vue';
import store from '@/store';
import { WorkflowStep } from '@/store/getStarted';

import CogsDefinition from '@/components/widgets/CogsDefinition.vue';
import GetStartedNav from '@/components/getStarted/GetStartedNav.vue';
import PacketKindSelector from '@/components/PacketKindSelector.vue';

export default Vue.extend({
  components: {
    CogsDefinition,
    GetStartedNav,
    PacketKindSelector
  },

  methods: {
    chooseSinglePoint() {
      store.dispatch.getStarted.goToStep(WorkflowStep.BUILD_SINGLE_POINT_GOALS);
    },

    chooseMultiPoint() {
      store.dispatch.getStarted.goToStep(WorkflowStep.BUILD_MULTI_POINT_GOALS);
    }
  }
});
